import React, { Component } from "react";
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import moment from "moment";
import ReactToPrint from "react-to-print";
import {Spinner} from "react-bootstrap-v5";
import { reportService } from "../../Services/reportService";
import { retailerService } from "../../Services/retailerService";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class RetailerPurchaseInvoice extends Component {
  state = {
    reportObj: [],
    retailersObj: [],
    startDate: "",
    endDate: "",
    referral_token: "",
    loader:false
  };

  componentDidMount() {
    this.componentRef = React.createRef();
    this.getRetailerPurchaseInvoice();
    this.getRetailers();
  }

  getRetailers = () => {
    retailerService.getAllRetailer().then((result) => {
      if (result.status === true) {
        this.setState({ retailersObj: result.data });
      }
    });
  };

  getRetailerPurchaseInvoice = (params = {}) => {
    this.setState({loader:true})
    reportService.getRetailerPurchaseInvoice(params).then((result) => {
      if (result.status === true) {
        this.setState({ reportObj: result.data });
      } else {
        toast.info("Something went wrong");
      }
    this.setState({loader:false})
    });
  };

  // handleModeChange = (mode) => {
  //   this.setState({ referral_token: mode },()=>{
  //       let search = {
  //           startDate: this.state.startDate,
  //           endDate: this.state.endDate,
  //           referral_token: mode,
  //         };
  //         this.getRetailerPurchaseInvoice(search);
  //   });
  // };

  handleInputChange = (e) => {
    let search = {startDate: this.state.startDate, endDate: this.state.endDate,referral_token: e.target.value}
    this.getRetailerPurchaseInvoice(search)
    this.setState({referral_token: e.target.value})
}

  exportToExcel = () => {
    let params = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      referral_token: this.state.referral_token,
    };
    reportService.exportRetailerPurchaseInvoice(params).then((result) => {
      if (result.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

//   handleDateChange = (e) => {
//     const { name, value } = e.target;

//     let setdate = name === "start_date" ? "startDate" : "endDate";
//     this.setState({ [setdate]: new Date(value).getTime() }, () => {
//       if (this.state.startDate !== "" && this.state.endDate !== "") {
//         let search = {
//           startDate: this.state.startDate,
//           endDate: this.state.endDate,
//           referral_token: this.state.referral_token,
//         };
//         this.getRetailerPurchaseInvoice(search);
//       }
//     });
//   };


 //date selection function //neha
handleDateChange = (e) => {
    const { name, value } = e.target;
    let setdate = name === "start_date" ? "startDate" : "endDate";
  
    const selectedDate = new Date(value).getTime();
    this.setState({ [setdate]: selectedDate }, () => {
      const { startDate, endDate } = this.state;
  
      if (startDate !== "" && endDate !== "") {
        if (startDate > endDate) {
          this.setState({ startDate: "", endDate: "" });
          toast.info("Start date cannot be greater than end date.");
        
        } else {
          let search = {
            startDate: startDate,
            endDate: endDate,
            referral_token: this.state.referral_token,
          };
  
          this.getRetailerPurchaseInvoice(search);
        }
      }
    });
  };
  render() {
    const { reportObj, retailersObj } = this.state;
    let total = 0;
    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Retailer Purchase Invoice</h4>
        </div>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3} className="mb-3">
              {/* <Form.Label>Retailer</Form.Label>
              <Form.Select
                name="retailer"
                onChange={(e) => this.handleModeChange(e.target.value)}
              >
                <option value="">All Retailer</option>
                {retailersObj.length &&
                  retailersObj.map((item) => (
                    <option value={item._id}>{item.retailer_name}</option>
                  ))}
              </Form.Select> */}
              <Form.Label>Search</Form.Label>
                            <Form.Control
                                type="text"
                                name="search"
                                placeholder='Search Retailer'
                                onChange={(e) => this.handleInputChange(e)}
                            />
            </Col>

            <Col md={3}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3} className="mt-3">
              <div className="d-flex justify-content-end mt-1">
              <Button
                className="me-3 ps-4 pe-4"
                variant="success"
                onClick={() => this.exportToExcel()}
              >
                Excel
              </Button>
              <ReactToPrint
                trigger={() => {
                  return <Button variant="secondary" className="ps-4 pe-4">Print</Button>;
                }}
                content={() => this.componentRef}
                bodyClass={"printElement"}
              />
              </div>
            </Col>
          </Row>

          <Row className="printElement" ref={(el) => (this.componentRef = el)}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Job Number</th>
                  <th>Retailer Name</th>
                  <th>Referral Code</th>
                  <th>Invoice Number</th>
                  <th>Date</th>
                  <th>Invoice Value</th>
                  <th>Product</th>
                </tr>
              </thead>
              {this.state.loader &&
                    <tbody>
                        <tr>
                            <td colSpan={20} className='text-center'>
                        <Spinner animation="border" />
                            </td>
                        </tr>
                    </tbody> 
                  || 
              <tbody>
                {reportObj.length &&
                  reportObj.map((item, index) => {
                    total = total + Number(item.invoice_value);

                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item?.job_token}</td>
                        <td>{item?.retailer_name}</td>
                        <td>{item?.referral_code}</td>
                        <td>{item?.invoice_number}</td>
                        <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                        <td>{item?.invoice_value?.toFixed(2)}</td>
                        <td>{item?.cargo_type}</td>
                      </tr>
                    );
                  }) || <tr><td colSpan={20} className="text-center">Data Not Available</td></tr>
                  }

                {
                  <tr>
                    <td colSpan={3}>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{total.toFixed(2)}</td>
                    <td colSpan={2}></td>
                  </tr>
                }
              </tbody>}
            </Table>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { RetailerPurchaseInvoice };
